// extracted by mini-css-extract-plugin
export default {"Content":"AccountsManagement_Content__5OkMf","ManagementLink":"AccountsManagement_ManagementLink__7K8sx"};